namespace RioERP.Orders {
    @Serenity.Decorators.registerClass()
    export class AddBookDialog extends Serenity.EntityDialog<OrderBookRow, any> {
        loadedState: string;
        protected getFormKey() { return "Orders.AddBook"; }
        protected form = new AddBookForm(this.idPrefix);
        private orderId: number;
        constructor(orderId: number) {
            super();
            this.orderId = orderId;
            this.dialogTitle = "Scan and Add Book";
        }
      

        protected getDialogTitle(): string {
            return "Scan And Add Book";
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
            // Set the OrderId value in the form
         
            this.form.OrderId.value = this.orderId;
        }

        protected getDialogButtons(): Serenity.DialogButton[] {
            return [
                {
                    text: 'Add Book',
                    click: () => {
                        if (!this.validateBeforeSave())
                            return;

                        if (Q.isEmptyOrNull(this.form.BookIsbn.value)) {
                            Q.notifyError("Please enter the ISBN!");
                            return;
                        }

                        OrdersService.ScanBook({
                            BookIsbn: this.form.BookIsbn.value,
                            OrderId: this.form.OrderId.value,
                        }, (response: Serenity.ServiceResponse) => {
                            if (response.Error) {
                                Q.notifyError(response.Error.Message);
                            } else {
                                Q.notifyInfo('Book successfully added.');

                                this.dialogClose();

                            }
                        });
                    },
                },
                {
                    text: 'Cancel',
                    click: () => this.dialogClose()
                }
            ];
        }
    }
}